/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_References_Tool_Connection_MutedInputs */



/**
* | output |
* | --- |
* | "Switched off by you" |
*
* @param {Project_References_Tool_Connection_MutedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_references_tool_connection_muted = /** @type {((inputs?: Project_References_Tool_Connection_MutedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_References_Tool_Connection_MutedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Von Ihnen deaktiviert")
	return /** @type {LocalizedString} */ ("Switched off by you")
});